module.exports = window.__loadMfRemote("postSaleChanges", "postSaleChangesUrl");